import { RouteRecordRaw } from "vue-router";

const countries: RouteRecordRaw = {
  path: "countries",
  component: () => import("@/views/public/index.vue"),
  meta: {
    title: "الدول",
  },
  children: [
    {
      path: "",
      alias: "index",
      name: "index-countries",
      component: () => import("@/views/public/countries/pages/index.vue"),
      meta: {
        pageId: 18010400,
        role: "view",
        title: "الدول",
      },
    },
    {
      path: "add",
      name: "add-country",
      component: () => import("@/views/public/countries/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "add",
        title: "AddNew",
      },
    },
    {
      path: "Edit/:Id",
      props: true,
      name: "edit-country",
      component: () => import("@/views/public/countries/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "edit",
        title: "Edit",
      },
    },
  ],
};

export default countries;
